/* eslint-disable array-callback-return */
// document https://docs.dhtmlx.com/gantt/api__refs__gantt.html
import { arrowLeft, arrowRight, closeIcon, dateRange } from 'assets';
import { DatePickerAntdField } from 'components';
import { STATUS_MODAL } from 'constant';
import { Gantt, GanttConfigOptions, GanttStatic } from 'dhtmlx-gantt';
import 'dhtmlx-gantt/codebase/dhtmlxgantt.css';
import { useQueryParams } from 'hooks';
import { dayjs } from 'libs';
import { debounce, sortBy, uniq } from 'lodash';
import ConfirmUpdateSchedule from 'pages/Home/Bo/ConfirmUpdateSchedule';
import ModalAddHistoryWork from 'pages/Home/Bo/ModalAddHistoryWork';
import React, { FC, useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { renderToString } from 'react-dom/server';
import * as Types from 'types';
import { WorkerShift } from 'types';
import { Spin } from 'antd';
import { BoxChangeDateTime, ContainerGantt, GlobalStyle, PropsGantt } from './styles';

export type GanttChartProps = PropsGantt &
  Partial<GanttConfigOptions> & {
    refreshData?: () => void;
    data: WorkerShift[];
    type: 'default' | 'group';
    config?: Partial<GanttConfigOptions>;
    width?: string;
    height?: string;
    showIconDate?: boolean;
    formatChangeDateTime?: string;
    onChangeDate?: (date: Date) => void;
    currentDate?: Date | string;
    className?: string;
    boderDash?: boolean;
    bar_height?: number;
    row_height?: number;
    grid_width?: number;
    min_column_width?: number;
    scale_height?: number;
    labelColumnSideBarLeft?: string;
    isReadonly?: boolean;
    activeDay?: Date | string;
    quick_info?: boolean;
    setIsReadonly?: (status: boolean) => void;
    hideBoxButtonInfo?: boolean;
    onDelete?: (data: WorkerShift, callback?: () => void) => void;
    columGranttGroup?: {
      name?: string;
      label?: string;
      width?: number;
      tree?: boolean;
    }[];
    callBackDataDragEdit?: (data: WorkerShift[], originData: WorkerShift[] | []) => void;
    onAddScheduleUser?: ({
      data,
      dataModalTask,
    }: {
      data: Types.PostUserSchedulesUpdateParams;
      dataModalTask?: ModalAddEdit | undefined;
    }) => void;
  };
export type ContainerChangeTimeProps = {
  onChangeDate?: (date: Date) => void;
  showIconDate?: boolean;
  formatChangeDateTime?: string;
  type?: 'time' | 'date' | 'week' | 'month' | 'quarter' | 'year' | undefined;
  enableDisableNextTime?: boolean;
  nextMaxDay?: Date | string;
  boderDatePicker?: boolean;
  readonlyDatePicker?: boolean;
  currentDateProps?: Date | string;
};
export type ItemProps = {
  className?: string;
  duration?: number;
  end_date?: Date;
  id?: number | string;
  isChild?: boolean;
  isParent?: boolean;
  label?: string;
  parent?: string;
  progress?: number;
  start_date?: Date;
  text?: string;
  label_Column?: string;
  operator?: string;
  label_task?: string;
  locale?: string;
  user_id?: string | number;
};
export type ModalAddEdit = {
  dataEdit?: WorkerShift[];
  dataAdd?: WorkerShift;
  data?: WorkerShift[];
  allData?: WorkerShift[];
  dataDateInit?: string[] | Date[];
  typeModal: number;
  addNew?: boolean;
  taskInformation?: WorkerShift;
};
const GanttChart: FC<GanttChartProps> = ({
  loading = false,
  width = '100%',
  height = '500px',
  type = 'default',
  data = [],
  hideBoxButtonInfo = false,
  currentDate,
  className,
  labelColumnSideBarLeft = '現場名',
  boderDash = false,
  bar_height = 16,
  row_height = 33,
  grid_width = 200,
  min_column_width = 34,
  scale_height = 33,
  readonly = true,
  activeDay = dayjs().format('YYYY-MM-DD'),
  setIsReadonly = () => console.log('setIsReadonly'),
  config = {},
  isReadonly = true,
  autosize = 'y',
  quick_info = false,
  refreshData = () => null,
  callBackDataDragEdit = () => null,
  onAddScheduleUser,
  onDelete,
  columGranttGroup = [
    {
      name: 'work_type',
      label: '工種',
      width: 70,
    },
    {
      name: 'text',
      label: '業者/作業員',
      width: 130,
      tree: true,
    },
  ],
}) => {
  const ganttContainer = useRef<HTMLElement>(null);
  const [isModalAddHistoryWork, setIsModalAddHistoryWork] = useState<boolean>(false);
  const [typeModalAddHistoryWork, setTypeModalAddHistoryWork] = useState<Number>(STATUS_MODAL.ADD);
  const [dataModalTask, setDataModalTask] = useState<ModalAddEdit>();
  const [isModalVisibleModalScheduleConfirmation, setIsModalVisibleModalScheduleConfirmation] =
    useState<boolean>(false);
  const callBackDataDragEditRef = useRef<ReturnType<typeof setInterval>>();
  const taskUpdateOnDrag = useRef<WorkerShift[]>([]);
  const dataUpdate = useRef<Types.PostUserSchedulesUpdateParams>();
  const openModalEditAddTask = useCallback((e: ModalAddEdit) => {
    if (e) {
      setDataModalTask(e);
      setIsModalAddHistoryWork(true);
      e?.typeModal && setTypeModalAddHistoryWork(e?.typeModal);
    }
  }, []);
  const gantt = useRef(Gantt.getGanttInstance()).current;

  useEffect(() => {
    if (isReadonly && taskUpdateOnDrag.current.length > 0) {
      taskUpdateOnDrag.current = [];
      callBackDataDragEdit([], []);
    }
  }, [callBackDataDragEdit, isReadonly]);
  useLayoutEffect(() => {
    initGantt(gantt, {
      config: {
        bar_height,
        row_height,
        grid_width,
        min_column_width,
        scale_height,
        readonly,
        autosize,
        ...config,
      },
      data,
      hideBoxButtonInfo,
      columGranttGroup,
      setIsReadonly,
      quick_info,
      activeDay,
      isReadonly,
      currentDate,
      labelColumnSideBarLeft,
      type,
      openModalEditAddTask,
    });

    gantt.$click.buttons.button_delete = function (_id: string | number) {
      const itemDelete = data?.find((itemData) => itemData.id === _id);

      // custom modal delete
      gantt.confirm({
        text: 'この操作は元に戻せません',
        title: '予定を削除します。作業員の該当現場の予定が全て削除されます。よろしいですか？',
        type: 'delete-popup',
        ok: '削除',
        cancel: 'キャンセル',
        callback: async function (result: boolean) {
          if (
            result &&
            itemDelete?.building_id &&
            itemDelete?.work_type_id &&
            itemDelete?.user_id
          ) {
            onDelete && onDelete(itemDelete, () => gantt.deleteTask(itemDelete.id));
          }

          // if (result && _id) {
          //   ganttStatic.deleteTask(_id);
          //   return;
          // }
          return;
        },
      });
      return false; //blocks the default behavior
    };

    gantt.attachEvent(
      'onAfterTaskUpdate',
      function (id: number) {
        const taskDrag = gantt.getTask(id);
        console.log('==============onAfterTaskUpdate=taskDrag=====================');

        const cloneTaskUpdateOnDrag = [...taskUpdateOnDrag.current];
        // cho các mảng đã sửa vào taskUpdateOnDrag.current
        const findItemHasArray = cloneTaskUpdateOnDrag.findIndex((item) => item?.id === id);
        if (findItemHasArray !== -1) {
          cloneTaskUpdateOnDrag[findItemHasArray] = taskDrag;
        } else {
          taskUpdateOnDrag.current = [...cloneTaskUpdateOnDrag, taskDrag];
        }
        if (callBackDataDragEditRef.current) {
          clearTimeout(callBackDataDragEditRef.current);
        }
        callBackDataDragEditRef.current = setTimeout(
          () => callBackDataDragEdit(taskUpdateOnDrag.current, cloneTaskUpdateOnDrag),
          500
        );
      },
      {}
    );

    gantt.config.start_date = dayjs(currentDate).startOf('month').toDate();
    gantt.config.end_date = dayjs(currentDate).endOf('month').toDate();
    gantt.plugins({
      click_drag: true,
      drag_timeline: true,
    });
    gantt.init(ganttContainer.current ?? '');
    const dataTestNew: Types.WorkerShift[] = data.map((item) => ({
      ...item,
      end_date: dayjs(item.end_date).isValid()
        ? dayjs(item.end_date).add(1, 'day').format('YYYY-MM-DD')
        : '',
      start_date: dayjs(item.start_date).isValid()
        ? dayjs(item.start_date).format('YYYY-MM-DD')
        : '',
    }));
    gantt.parse({ data: JSON.parse(JSON.stringify(dataTestNew)) });

    return function () {
      gantt.clearAll();
    };
  }, [
    taskUpdateOnDrag,
    quick_info,
    type,
    data,
    openModalEditAddTask,
    currentDate,
    bar_height,
    row_height,
    grid_width,
    min_column_width,
    scale_height,
    labelColumnSideBarLeft,
    config,
    readonly,
    autosize,
    activeDay,
    isReadonly,
    setIsReadonly,
    columGranttGroup,
    hideBoxButtonInfo,
    callBackDataDragEdit,
    refreshData,
    onDelete,
    gantt,
  ]);

  return (
    <>
      {/* test */}
      <GlobalStyle />
      <ConfirmUpdateSchedule
        visible={isModalVisibleModalScheduleConfirmation}
        onOK={async () => {
          setIsModalVisibleModalScheduleConfirmation(false);
          if (dataUpdate.current) {
            onAddScheduleUser && (await onAddScheduleUser({ data: dataUpdate.current }));
          }
        }}
        onCancel={() => {
          setIsModalVisibleModalScheduleConfirmation(false);
        }}
      />
      {isModalAddHistoryWork && (
        <ModalAddHistoryWork
          visible={isModalAddHistoryWork}
          type={typeModalAddHistoryWork}
          currentDate={currentDate}
          dataForm={dataModalTask}
          onCancel={() => {
            setIsModalAddHistoryWork(false);
          }}
          onOk={async (data: Types.PostUserSchedulesUpdateParams) => {
            setIsModalAddHistoryWork(false);
            if (!data) {
              return;
            }
            try {
              if (data.out_of_schedule === 1) {
                dataUpdate.current = data;
                setIsModalVisibleModalScheduleConfirmation(true);
              } else {
                onAddScheduleUser && (await onAddScheduleUser({ data, dataModalTask }));

                // refreshData && (await refreshData());
              }
            } catch (error) {
              console.error(error);
            }
          }}
        />
      )}

      <Spin spinning={loading} size={'large'}>
        <ContainerGantt
          ref={ganttContainer}
          className={`${type === 'default' ? 'gantt' : 'gantt-group'} ${className}`}
          boderDash={boderDash}
          width={width}
          height={height}
        />
      </Spin>
    </>
  );
};

function initGantt(
  ganttStatic: GanttStatic,
  {
    hideBoxButtonInfo,
    type,
    config,
    openModalEditAddTask,
    labelColumnSideBarLeft,
    currentDate,
    activeDay,
    isReadonly,
    setIsReadonly,
    quick_info,
    columGranttGroup,
    data,
  }: Partial<GanttChartProps>
) {
  ganttStatic.i18n.setLocale('jp');

  for (let key in config) {
    ganttStatic.config[key] = config[key];
  }
  ganttStatic.config.select_task = false;
  ganttStatic.config.date_format = '%Y-%m-%d %H:%i';
  ganttStatic.config.touch = true;
  ganttStatic.config.touch_drag = true;
  ganttStatic.config.drag_move = true;
  ganttStatic.config.min_grid_column_width = 127;
  ganttStatic.config.details_on_dblclick = true;
  ganttStatic.plugins({
    quick_info: quick_info,
  });
  ganttStatic.config.quickinfo_buttons = ['button_edit', 'button_delete'];
  ganttStatic.locale.labels['button_delete'] = '削除';
  ganttStatic.locale.labels['button_edit'] = '編集';
  ganttStatic.$click.buttons.button_edit = function (_id: any) {
    const taskInformation = ganttStatic.getTask(_id);
    if (_id && openModalEditAddTask) {
      const listData = data
        ?.filter((itemData) => itemData.parent === taskInformation?.parent)
        .map((d) => ({
          ...d,
          work_type_id: d.work_type_id === 'undefined' ? undefined : d.work_type_id,
          building_id: d.building_id === 'undefined' ? undefined : d.building_id,
        }));

      const dataDateInit: string[] = [];
      if (listData && listData.length > 0) {
        listData.map((itemDate) => {
          if (itemDate?.start_date) {
            dataDateInit.push(dayjs(itemDate.start_date).format('YYYY-MM-DD').toString());
          }
          if (itemDate?.end_date) {
            dataDateInit.push(
              dayjs(itemDate.end_date).add(-1, 'day').format('YYYY-MM-DD').toString()
            );
          }
        });
      }
      // https://github.com/Leadingwin-DX/dtc-dx-system/issues/3048
      // setIsReadonly && setIsReadonly(false);
      openModalEditAddTask({
        dataEdit: listData,
        allData: data,
        dataDateInit: sortBy(uniq(dataDateInit)),
        taskInformation,
        typeModal: STATUS_MODAL.EDIT,
      });
    }
  };

  ganttStatic.locale.labels.confirm_deleting = 'この予定を削除します。よろしいですか？';

  ganttStatic.attachEvent(
    'onQuickInfo',
    function (_taskId) {
      const targetCloseQuickInfo = document?.getElementById('btn-close-quickinfo');
      const targetButtonDelete = document?.getElementsByClassName('gantt_cal_qi_controls');
      const taskInformation = ganttStatic.getTask(_taskId);
      if (hideBoxButtonInfo) {
        targetButtonDelete?.[0].classList.remove('d-inline-flex');
        targetButtonDelete?.[0].classList.add('d-none');
      }
      if (targetButtonDelete?.[0]) {
        //nếu có label_Column(loại công trường thì ẩn button xoá)
        if (taskInformation?.label_Column) {
          targetButtonDelete?.[0].classList.remove('d-inline-flex');
          targetButtonDelete?.[0].classList.add('d-none');
        } else {
          targetButtonDelete?.[0].classList.remove('d-none');
          targetButtonDelete?.[0].classList.add('d-inline-flex');
        }
      }
      // add action close button  modal quickInfo
      if (targetCloseQuickInfo) {
        const idTasks = targetCloseQuickInfo.getAttribute('data-id');
        targetCloseQuickInfo.addEventListener('click', function () {
          ganttStatic.ext.quickInfo.hide(idTasks);
        });
      }
    },
    {}
  );
  ganttStatic.templates.quick_info_title = function (start, end, task) {
    return renderToString(
      <div className="quick_info_title">
        <img
          src={closeIcon}
          className="cursor-pointer btn-close-quickinfo"
          id="btn-close-quickinfo"
          data-id={task.id}
          alt="closeIcon"
          width="16"
          height="16"
        />
      </div>
    );
  };
  ganttStatic.templates.quick_info_date = function (_start, _end, _task) {
    return ``;
  };
  ganttStatic.templates.quick_info_content = function (_start, _end, task) {
    return renderToString(
      <div>
        <div className="title">{task?.building_code}</div>
        {task?.label && !task?.title_quickinfo && (
          <div className="title">{task?.label ? task.label : ''}</div>
        )}
        {!task?.label && task?.title_quickinfo && (
          <div className="title">{task?.title_quickinfo ? task.title_quickinfo : ''}</div>
        )}
        <div className="content">
          <span>種別:</span> {task?.localeQuickInfo}
        </div>
        <div className="content">
          <span>
            <span>期間:</span> {dayjs(task.start_date).format('YYYY/MM/DD')} 〜
            {dayjs(task.end_date).add(-1, 'day').format('YYYY/MM/DD')}
          </span>
        </div>
        <div className="content">
          {task?.operator && (
            <span>
              <span>作業員:</span> {task?.operator}
            </span>
          )}
        </div>
      </div>
    );
  };
  // custom readonly for item
  ganttStatic.attachEvent(
    'onTaskLoading',
    function (_task: any) {
      if (isReadonly && _task.IsEditable) {
        _task.editable = false;
      }
      if (isReadonly === false && _task.IsEditable) {
        _task.editable = true;
      }
      return true;
    },
    {}
  );
  ganttStatic.templates.task_text = (_start, _end, task: ItemProps) => {
    return renderToString(
      <div className="task d-flex align-center">
        {task.locale ? (
          <>
            <span className="task-locale">{task.locale}</span>
          </>
        ) : (
          ''
        )}
        {task.label ? <span>{task.label}</span> : ''}
      </div>
    );
  };
  ganttStatic.templates.task_class = (start, end, task) => {
    if (start < dayjs(currentDate).startOf('month').toDate()) {
      return `${task.className} gantt_task_line_split_start`;
    }
    if (end > dayjs(currentDate).endOf('month').toDate()) {
      return `${task.className} gantt_task_line_split_end`;
    }
    return task.className;
  };
  ganttStatic.config.external_render = {
    isElement: React.isValidElement,
    renderElement: ReactDOM.render,
  };
  ganttStatic.templates.timeline_cell_class = (_item, date) => {
    if (dayjs(activeDay).format('YYYY-MM-DD') === dayjs(date).format('YYYY-MM-DD')) {
      return 'timeline_scale_cell_class';
    }
    if (date.getDay() === 0 || date.getDay() === 6) {
      return 'weekend';
    }
    return '';
  };
  if (type === 'default') {
    ganttStatic.attachEvent(
      'onTaskClick',
      function (_id, e) {
        return e.target.className.includes('gantt_tree_icon');
      },
      {}
    );

    ganttStatic.templates.scale_cell_class = (date) => {
      if (date.getDay() === 0 || date.getDay() === 6) {
        return 'weekend';
      }

      return '';
    };

    ganttStatic.templates.grid_folder = (item) => {
      return `<div class='gantt_tree_icon gantt_folder_${item.$open ? 'open' : 'closed'}'></div>`;
    };

    ganttStatic.templates.grid_file = (_item) => {
      return "<div class='gantt_tree_icon gantt_file'></div>";
    };

    ganttStatic.config.drag_links = false;
    ganttStatic.config.work_time = false;
    ganttStatic.config.drag_progress = false;

    ganttStatic.config.layout = {
      css: 'gantt_container',
      rows: [
        {
          cols: [
            {
              id: 'grid',
              view: 'grid',
              config: {
                columns: [
                  {
                    name: 'text',
                    label: renderToString(
                      <>
                        <div className="gantt_grid_label">工種</div>
                        <div className="gantt_grid_value">{labelColumnSideBarLeft}</div>
                      </>
                    ),
                    tree: true,
                    onrender(item: WorkerShift) {
                      if (item.isParent) {
                        return (
                          <div className="gantt_grid_parent">
                            <div
                              className="fs-12 cursor-pointer"
                              onClick={() => {
                                item &&
                                  openModalEditAddTask &&
                                  openModalEditAddTask({
                                    allData: data,
                                    dataAdd: {
                                      ...item,
                                      work_type_id: item.work_type_id,
                                    },
                                    building_id: item.building_id,
                                    typeModal: STATUS_MODAL.ADD,
                                    taskInformation: item,
                                    addNew: true,
                                  });
                              }}
                            >
                              ＋予定を追加
                            </div>
                            <div className="gantt_grid_head">{item.text}</div>
                          </div>
                        );
                      }
                      if (item.isChild) {
                        return <div className="gantt_grid_head gantt_grid_child">{item.text}</div>;
                      }
                      return (
                        <div className="gantt_grid_head">
                          {item?.label_Column && (
                            <div className="gantt_grid_label">{item?.label_Column}</div>
                          )}
                          <div className="gantt_grid_value">
                            <div>{item.building_code}</div>
                            {item.text}
                          </div>
                        </div>
                      );
                    },
                  },
                ],
              },
              width: 250,
              scrollY: 'scrollVer',
            },
            {
              resizer: true,
              width: 1,
            },
            {
              view: 'timeline',
              id: 'timeline',
              config: {
                scales: [
                  {
                    unit: 'day',
                    step: 1,
                    format(date: Date) {
                      return `<span class="fs-12" >${date.getDate()}</span><span class="fs-10">${dayjs(
                        date
                      ).format('ddd')}</span>`;
                    },
                    css(date: Date) {
                      if (
                        dayjs(activeDay).format('YYYY-MM-DD') === dayjs(date).format('YYYY-MM-DD')
                      ) {
                        return 'active_scale_cell_class scales_date_time';
                      }
                      return 'scales_date_time';
                    },
                  },
                ],
              },
              scrollX: 'scrollHor',
              bindLinks: null,
              scrollY: 'scrollVer',
            },
            {
              view: 'scrollbar',
              id: 'scrollVer',
            },
          ],
        },
        {
          view: 'scrollbar',
          id: 'scrollHor',
          height: 8,
        },
      ],
    };
    ganttStatic.templates.task_row_class = function (_start, _end, task) {
      if (task.isWorktype) {
        return 'isWorktype';
      }
      if (task.isSeparate) {
        return `gantt_task_row_separate`;
      }
      if (task.isParent) {
        return 'gantt_task_row_parent';
      }
      return '';
    };

    ganttStatic.templates.grid_row_class = function (_start, _end, task) {
      if (task.isSeparate) {
        return 'gantt_grid_separate';
      }
      if (task.isLabel) {
        return 'gantt_grid_label';
      }
      if (task.isParent) {
        return 'gantt_grid_group';
      }
      if (task.isChild) {
        return 'gantt_grid_item';
      }
      return 'gantt_grid_default';
    };
  } else {
    ganttStatic.attachEvent(
      'onTaskClick',
      function (_id, e) {
        return e.target.className !== 'gantt_tree_content';
      },
      {}
    );
    ganttStatic.templates.grid_folder = (item) =>
      `<div class='gantt_folder_${item.$open ? 'open' : 'closed'}'></div>`;
    ganttStatic.templates.grid_file = () => "<div class='gantt_tree_icon gantt_file'></div>";
    ganttStatic.config.layout = {
      css: 'gantt_container',
      rows: [
        {
          cols: [
            {
              id: 'grid',
              view: 'grid',
              config: {
                columns: columGranttGroup,
              },
              width: 250,
              scrollY: 'scrollVer',
            },
            {
              resizer: true,
              width: 1,
              group: 'vertical',
            },
            {
              view: 'timeline',
              id: 'timeline',
              config: {
                scales: [
                  {
                    unit: 'day',
                    step: 1,
                    format(date: Date) {
                      return `<span class="fs-12" >${date.getDate()}</span><span class="fs-10">${dayjs(
                        date
                      ).format('ddd')}</span>`;
                    },
                    css(date: Date) {
                      if (
                        dayjs(activeDay).format('YYYY-MM-DD') === dayjs(date).format('YYYY-MM-DD')
                      ) {
                        return 'active_scale_cell_class scales_date_time';
                      }
                      return 'scales_date_time';
                    },
                  },
                ],
              },
              scrollX: 'scrollHor',
              bindLinks: null,
              scrollY: 'scrollVer',
            },
            { view: 'scrollbar', id: 'scrollVer', group: 'vertical' },
          ],
        },
        { view: 'scrollbar', id: 'scrollHor', height: 8 },
      ],
    };
  }
}

export const ContainerChangeTime: FC<ContainerChangeTimeProps> = ({
  onChangeDate = (date) => console.log(date), // callback date change
  showIconDate = false, // show icon calendar date
  formatChangeDateTime = 'YYYY/MM',
  type = 'month', // TOD type of change date day or month
  enableDisableNextTime = false,
  nextMaxDay = dayjs().format('YYYY/MM/DD'), // max date show button next
  boderDatePicker = true,
  readonlyDatePicker = false,
  currentDateProps, // if currentDateProps replace date state
}) => {
  const query = useQueryParams();
  const currentDateParams = query.get('curentDate')
    ? dayjs(query.get('curentDate')).toDate()
    : dayjs().toDate();
  const [currentDate, setCurrentDate] = useState<Date>(currentDateParams);

  // check show next button
  const checkShowButtonNext = useCallback(() => {
    let dateCurrent = currentDateProps ? currentDateProps : currentDate;
    if (
      enableDisableNextTime &&
      dayjs(dateCurrent).format(type === 'month' ? 'YYYY/MM' : 'YYYY/MM/DD') >=
        dayjs(nextMaxDay).format(type === 'month' ? 'YYYY/MM' : 'YYYY/MM/DD')
    ) {
      return false;
    }
    return true;
  }, [currentDate, currentDateProps, enableDisableNextTime, nextMaxDay, type]);

  const converTypeForDayjsAdd = type === 'date' ? 'day' : type;

  let PrevDate = debounce(() => {
    if (!currentDateProps) {
      setCurrentDate(dayjs(currentDate).add(-1, converTypeForDayjsAdd).toDate());
      onChangeDate(dayjs(currentDate).add(-1, converTypeForDayjsAdd).toDate());
      return;
    }
    onChangeDate(dayjs(currentDateProps).add(-1, converTypeForDayjsAdd).toDate());
  }, 300);
  let nextDate = debounce(() => {
    if (!currentDateProps) {
      setCurrentDate(dayjs(currentDate).add(1, converTypeForDayjsAdd).toDate());
      onChangeDate(dayjs(currentDate).add(1, converTypeForDayjsAdd).toDate());
      return;
    }
    onChangeDate(dayjs(currentDateProps).add(1, converTypeForDayjsAdd).toDate());
  }, 300);
  return (
    <BoxChangeDateTime>
      <div className="d-flex justify-center align-center">
        <span className="btn mr-8 cursor-pointer" onClick={PrevDate}>
          <img src={arrowLeft} alt="arrowLeft" />
        </span>
        <div className="text-date">
          <DatePickerAntdField
            picker={type}
            defaultValue={currentDateProps ? dayjs(currentDateProps) : dayjs(currentDate)}
            format={formatChangeDateTime}
            allowClear={false}
            value={currentDateProps ? dayjs(currentDateProps) : dayjs(currentDate)}
            className="date-Picker"
            bordered={boderDatePicker}
            inputReadOnly={readonlyDatePicker}
            onChange={(date) => {
              if (!currentDateProps) {
                setCurrentDate(dayjs(date).toDate());
              }
              onChangeDate(dayjs(date).toDate());
            }}
            disabledDate={(date) => {
              if (enableDisableNextTime && dayjs(date).format('YYYY/MM/DD') > nextMaxDay) {
                return true;
              }
              return false;
            }}
            suffixIcon={
              showIconDate && (
                <span className="icon-date">
                  <img src={dateRange} alt="dateRange" />
                </span>
              )
            }
          />
        </div>
        {checkShowButtonNext() && (
          <span className="btn ml-8 cursor-pointer" onClick={nextDate}>
            <img src={arrowRight} alt="arrowRight" />
          </span>
        )}
      </div>
    </BoxChangeDateTime>
  );
};
export default GanttChart;
